<template>
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body text-center py-5 position-relative">
                <!-- Close (cross) button -->
                <button type="button" class="close position-absolute"
                    style="top: 12px; right: 16px; background: #151618; color: #fff; border: none; border-radius: 50%; width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; font-size: 1.3rem; z-index: 10;"
                    @click="modalClose">
                    <div aria-hidden="true">&times;</div>
                </button>
                <div class="py-4">
                    <div>
                        <h4 class="mb-3 font-weight-bold" style="color: #151618;">Unlock Premium Membership</h4>
                        <div class="subscription-offer mb-4 p-4 rounded shadow-sm"
                            style="background: #f8f9fa; border: 1px solid #e5e5e5;">
                            <div class="d-flex flex-column align-items-center">
                                <!-- <div v-if="plan && typeof plan.price === 'number'" class="display-4 font-weight-bold mb-2" style="color: #151618;">
                                    ${{ formattedPrice }} 
                                    <span class="h5 font-weight-normal" style="color: #888;">/month</span>
                                </div>
                                <div v-if="plan" class="h5 mb-2" style="color: #151618;">{{ plan.title }}</div> -->
                                <!-- <div class="mb-3 text-muted" style="max-width: 320px;">{{ plan.description }}</div> -->
                                <ul class="list-unstyled mb-3">
                                    <li><i class="fa fa-check text-success mr-2"></i> Unlimited shifts creation</li>
                                    <li><i class="fa fa-check text-success mr-2"></i> No Deduction on every shift creation.</li>
                                    <li><i class="fa fa-check text-success mr-2"></i> Priority support</li>
                                </ul>
                                <button class="btn btn-primary blue px-2 py-2 mt-2" @click="onGetMembership">Get Membership</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'MemberShipModal',
    data() {
        return {
            // plan: {},
        };
    },
    methods: {
        modalClose() {
            this.$emit('close');
        },
        onGetMembership() {
            this.$emit('get-membership');
        },
        // async getSubscriptionPlan() {
        //     try {
        //         const response = await axios.get('/subscription/plans');
        //         if (response.data && response.data.plans && response.data.plans.length > 0) {
        //             return response.data.plans[0];
        //         } else if (Array.isArray(response.data) && response.data.length > 0) {
        //             return response.data[0];
        //         }
        //         return null;
        //     } catch (e) {
        //         console.log('Error:', e);
        //         return null;
        //     }
        // }
    },
    computed: {
        // formattedPrice() {
        //     return (this.plan && typeof this.plan.price === 'number')
        //         ? this.plan.price.toFixed(2)
        //         : '';
        // }
    },
    async mounted() {
        // this.plan = await this.getSubscriptionPlan();
    }
};
</script>

<style scoped>
.subscription-offer {
    transition: box-shadow 0.2s;
}

.subscription-offer:hover {
    box-shadow: 0 8px 32px rgba(21, 22, 24, 0.12);
}

.custom-spinner {
    width: 3rem;
    height: 3rem;
    border: 0.4rem solid #e5e5e5;
    border-top: 0.4rem solid #151618;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>